<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  mounted() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', process.env.VUE_APP_RCPT_LIB_URL)
    document.head.appendChild(recaptchaScript)
  },
  computed: {
    ...mapGetters("err", ["isError"]),
  },
  watch: {
    isError(value) {
      if (value === true) {
        this.$router.push("/error")
      }
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Noto+Sans+JP:wght@400;700&display=swap");

#app {
  font-size: 12pt;
  font-family: 'Lato', 'Noto Sans JP', 'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
}
</style>
